import { fromJS } from 'immutable';

import { reducerFactory } from '@Utils/Redux/reducerFactory';

export const initialState = fromJS({});
export const reducerKey = 'RcsSupplierInfo';
export const saveRcsSupplierDataByIdType = 'saveRcsSupplierDataByIdType';

export const actionsSpec = {
  [saveRcsSupplierDataByIdType]: (state, action) => {
    const { databaseId, crn, item } = action.payload;

    return state.setIn([databaseId, crn], fromJS(item));
  },
};

export const { reducer, actionTypes } = reducerFactory(actionsSpec, initialState);
